import { Injectable } from '@angular/core';
import { GeneratedClientManagerService } from '@cloud-twin-v2/generated/generated-client-manager.service';
import { PointClient } from '@cloud-twin-v2/generated/simulation.generated.client';
import { SelectOption } from '@common-modules/shared/model/shared/select-option';
import { Observable, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CtDimensionsService extends GeneratedClientManagerService {
  private _client: PointClient;

  constructor() {
    super();
    this._client = new PointClient(this.httpClient, this.baseUrl);
  }

  getDimensionsOptions(scenarioIds: string[]): Observable<SelectOption<string>[]> {
    return this.getDimensionsByScenario(scenarioIds).pipe(
      map((dimensions) =>
        dimensions.map(
          (dimension) =>
            new SelectOption<string>({
              value: dimension.name,
              label: dimension.alias ?? dimension.name,
            })
        )
      )
    );
  }

  getDimensionsByScenario(scenarioIds: string[]) {
    return this._client.getDimensions(scenarioIds);
  }
}
